import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB_1cJ4lmfUV_-7ha96T0EoLLz6F5hf_Ro",
    authDomain: "neta-e3506.firebaseapp.com",
    projectId: "neta-e3506",
    storageBucket: "neta-e3506.appspot.com",
    messagingSenderId: "885656467935",
    appId: "1:885656467935:web:25dc6e4f77e2d1e8fcec6a",
    measurementId: "G-3Z7GT2G2SP"
};
firebase.initializeApp(firebaseConfig);

export default firebase;